<script>
    import {showDialogLogin} from "../../../js/stores";
    import {onMount} from "svelte";

    onMount(() => {
        let elements = document.querySelectorAll('[data-modal]')

        for (let element of elements) {
            element.style.cursor = "pointer"

            element.addEventListener('click', () => {
                if (element.dataset?.modal) {
                    showDialogLogin.set({show: true, type: element.dataset.modal, data: {}})
                } else {
                    showDialogLogin.set({show: false, type: '', data: {}})
                }
            })
        }
    })
</script>

<i class="far fa-fw fa-circle-check"></i>
<div class="dc-title mb-3">{@html $showDialogLogin?.data?.title || ""}</div>
<p>{@html $showDialogLogin?.data?.text || ""}</p>

<style>
    i {
        font-size: 3rem;
        margin-bottom: 1.5rem;
    }
    .dc-title {
        font-size: 1.5rem;
        font-weight: 600;
    }
</style>